import React from 'react'
import CardFilter from './CardFilter'

const NumCard = () => {
  return (
    <div className='  lg:mt-20 mt-14'>
        <div className='w-full  flex flex-col '>
        <div className='number flex flex-col items-center justify-center'> 
        <h1 className='text-yellow-200 font-semibold text-lg border-richblack-700 border-l-2 pl-4 font-roboto'>Best Mehandi Artist in Delhi</h1>
        <h2 className='text-richblack-700 font-bold text-3xl mt-2 font-roboto'>Traditional Mehandi Art</h2>
        <h4 className='text-richblack-600 text-md mt-1'>[Bridal & Festival Mehandi Wala in Delhi]</h4>
        <p className='lg:text-lg text-richblack-500 lg:w-[52%] text-center mt-4 text-md'  >Using only the finest quality mehandi paste, our artists create beautiful and long-lasting
        designs for weddings and festive occasions that will leave you mesmerized.</p>
        <div className='mt-5'>
        <form className="flex flex-col lg:space-y-4 lg:mt-10 ">
          <div className="flex lg:flex-row flex-col lg:gap-6 gap-y-4">
            <div className="flex-1">
             
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Your Name"
                className="w-full px-4 py-2 border border-richblack-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="flex-1">
              
              <input
                type="tel"
                id="number"
                name="number"
                placeholder="Your Phone Number"
                className="w-full px-4 py-2 border border-richblack-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <button
            
            type="submit"
            className=" w-[8rem] px-4 py-2 bg-blue-600 text-white font-semibold rounded-md shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Submit
          </button>
          </div>
         
        </form>
        </div>
       

        </div>
        <div className='w-full mt-10'>
        <CardFilter/>
        </div>
       

        </div>
    </div>
  )
}

export default NumCard